/**
 * Locale-correct currency formatting (e.g. "45,00 €" / "$45.00" / "45,00 US$")
 * via Intl.NumberFormat, same "pass the app's i18n language explicitly
 * rather than trust a library's own locale" reasoning as dateFormatHelper's
 * own formatFullDate -- this always renders the right symbol/grouping/
 * decimal separator for both currencyCode AND locale, instead of a
 * hardcoded "{amount.toFixed(2)}€" that's wrong the moment either isn't EUR.
 *
 * Falls back to 'EUR' for an empty/invalid currencyCode rather than
 * throwing -- Intl.NumberFormat itself throws a RangeError on an
 * unrecognized ISO 4217 code, which would otherwise crash the whole price
 * display over one bad/missing value (e.g. a stale cached IHeavyDutyMachinery
 * fetched before hostCurrencyCode existed).
 */
export const formatCurrency = (amount: number, currencyCode: string, locale: string): string => {
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode || 'EUR' }).format(amount);
  } catch {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(amount);
  }
};
